
import React, { useState ,useEffect} from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Switch } from '@/components/ui/switch';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useToast } from '@/hooks/use-toast';
import { RootState } from '@/store';
import { getPriceWithInr } from '@/lib/utils';
import { venueUpdateById, getStaticConfig, getVendorVenueDetailsById, updateVendorSportAndCourtOnEdit, addNewCourtInVendorSports,deleteSportById } from '@/store/thunkMidddleware/turfMiddleware';
import { setSportsCategories } from '@/store/slices/turfSlice';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

import { addSport,resetLocalSports, addCourt, updateSport, updateCourt, deleteCourt, deleteSport, setEditSportAndCourtDetails, updateEditCourtDetails, updateEditSportDetails, setAddNewCourtState, resetAddNewCourtState } from '@/store/slices/turfSlice';
import { Plus, Eye, Trash2, Upload, Pencil, Trash, X, CheckCircle2, TriangleAlert, PlusIcon, PhoneCall } from 'lucide-react';
import { ButtonWithLoader } from '../ui/buttonwithloader';
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "@/components/ui/dialog"
import { Sports } from "@/types/interfaceType"
import VendorOnboardSkeleton from '@/components/skeletons/VendorOnboardSkeleton';
import { toast as newToast } from "@/components/ui/sonner";
import SportsCategoriesForm from './SportsCategoriesForm';
import Strings from '@/constants/String';



const SPORT_TYPES = [
  'Football', 'Cricket', 'Basketball', 'Tennis', 'Badminton', 'Volleyball',
  'Table Tennis', 'Swimming', 'Boxing', 'Hockey', 'Squash', 'Golf'
];

const SLOT_DURATIONS = [30, 60, 120];

interface SportsManagementFormProps {
  onNext: () => void;
  onBack: () => void;
  showActions?:boolean;
  showDeleteButtonForSaveVenues?:boolean
}

interface SportFields {
  name: string,
  sportType: string,
  description: string
}

const SportsManagementForm: React.FC<SportsManagementFormProps> = ({ onNext, onBack,showActions=true ,showDeleteButtonForSaveVenues=true}) => {
  const dispatch = useAppDispatch();
  const { sportsCategories, sports, currentOnboardVenueDetails, addNewCourtState, VendorVenueDetailsById, staticConfigResponse, venueUpdateByIdResponse, editSportAndCourtDetails, 
    updateVendorSportAndCourtOnEditResponse, addNewCourtInVendorSportsResponse ,deleteSportByIdResponse} = useAppSelector((state: RootState) => state.turf);
  const { toast } = useToast();
  const [isFormInputChanged, setIsFormInputChanged] = useState(false)
  const [currentTab, setCurrentTab] = useState('sports')
  const [showSportDetails, setShowSportDetails] = useState(false)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

  const [sportDetailsToView, setSportDetailsToView] = useState<Sports>(null);
  const [showAddNewSport, setShowAddNewSport] = useState<boolean>(null);

  const [selectedSportIdToDelete,setSelectedSportIdToDelete] = useState(null)
  const [selectedSportNameToDelete,setSelectedSportNameToDelete] = useState(null)

  const [selectedCategoriesFromProps,setSelectedCategoriesFromProps] = useState<string[]>([])
  const [isCategoriesFormInputChanged, setIsCategoriesFormInputChanged] = useState(false)
  const [ConfigStatus, setConfigStatus] = useState(Strings.groundConfigRadio.independent);
  const [selectedGroundUsage, setSelectedGroundUsage] = useState<string>(Strings.groundUsage.full);
  const [isSharedGround, setisSharedGround] = useState(false);

  // const [currentStep, setCurrentStep] = useState<OnboardingStep>('auth');
  const [newSport, setNewSport] = useState({
    name: '',
    sportType: '',
    description: '',
  });

  let initialCourtData =   {
    courtType:Strings.groundUsage.full,
    sharedGround: false as boolean,
    maxAllowedPlayers:null,
    courtName: '',
    description: '',
    images: [] as string[],
    arenaSize: {
      length: 0,
      width: 0,
      unit: 'meters' as 'meters' | 'feet'
    },
    isActive: true,
    slotDurationInMinutes: 60 as 30 | 60 | 120,
    pricingRules: {
      weekday: { dayRate: 0, nightRate: 0 },
      weekend: { dayRate: 0, nightRate: 0 },
      holidays: { dayRate: 0, nightRate: 0 }
    },
    availableSlots: [] as string[]
  }
  const [newCourt, setNewCourt] = useState(initialCourtData);

  const [selectedSportId, setSelectedSportId] = useState<string>("");
  //For the edit sport form
  const [openEditModal, setOpenEditmodal] = useState(false)
  const [openAddCourtModal, setOpenAddCourtModal] = useState(false)

  const [selectedCourtId, SetSelectedCourtId] = useState<string>('');

  const handleAddSport = () => {
    if (!newSport.name || !newSport.sportType) {
      // toast({ title: 'Error', description: 'Sport name and type are required', variant: 'destructive' });
      newToast.error('Sport name and type are required', { closeButton: true });
      return;
    }
    setIsFormInputChanged(true)
    dispatch(addSport(newSport));
    setNewSport({ name: '', sportType: '', description: '' });
    setCurrentTab("courts")
    // toast({ title: 'Success', description: 'Sport added successfully!' });
    newToast.success('Sport added successfully!', { closeButton: true });

  };

  useEffect(()=>{
    fetchVendorVenueDetailsById()
  },[])

  useEffect(() => {
    setisSharedGround(
      VendorVenueDetailsById?.payload?.groundConfig === Strings.groundConfigRadio.shared
    )
  }, [VendorVenueDetailsById?.payload?.groundConfig])

  const handleAddCourt = () => {
    if (!newCourt.courtName || !selectedSportId) {
      newToast.error('Court name and sport selection are required', { closeButton: true });

      // toast({ title: 'Error', description: 'Court name and sport selection are required', variant: 'destructive' });
      return;
    }
    setIsFormInputChanged(true)
    dispatch(addCourt({ sportId: selectedSportId, court: newCourt }));
    setSelectedSportId('')
    setConfigStatus(Strings.groundConfigRadio.independent)
    setSelectedGroundUsage(Strings.groundUsage.full)
    setNewCourt({
      courtType: Strings.groundUsage.full,
      sharedGround: false,
      maxAllowedPlayers:null,
      courtName: '',
      description: '',
      images: [],
      arenaSize: { length: 0, width: 0, unit: 'meters' },
      isActive: true,
      slotDurationInMinutes: 60,
      pricingRules: {
        weekday: { dayRate: 0, nightRate: 0 },
        weekend: { dayRate: 0, nightRate: 0 },
        holidays: { dayRate: 0, nightRate: 0 }
      },
      availableSlots: []
    });
    // toast({ title: 'Success', description: 'Court added successfully!' });
    newToast.success('Court added successfully!', { closeButton: true });

  };

  const handleDeleteCourt = (sportId: string, courtId: string) => {
    dispatch(deleteCourt({ sportId, courtId }))

  }

  const handleDeleteSport = (sportId: string) => {
    dispatch(deleteSport({ id: sportId }))
  }

  const handleDeleteSportFromDb=(sportId: string,venueId:string,sportType:string) => {
    setSelectedSportIdToDelete(sportId)
    setSelectedSportNameToDelete(sportType)

    setShowDeleteConfirmation(true)

    // dispatch(deleteSportById({venueId:venueId,payload:{sportId},callback:(res)=>{
    //   if(res?.payload){
    //     setSelectedSportIdToDelete(null)
    //     fetchVendorVenueDetailsById()
    //     // console.log("Delete Response of sport:",res)
    //   }
    // }}))
  }

  const deleteConfirmHandler=()=>{
      if(VendorVenueDetailsById?.payload?._id && selectedSportIdToDelete){
        dispatch(deleteSportById({venueId:VendorVenueDetailsById?.payload?._id ,payload:{sportId:selectedSportIdToDelete},callback:(res)=>{
          if(res?.payload){
            setSelectedSportIdToDelete(null)
            fetchVendorVenueDetailsById()
            // console.log("Delete Response of sport:",res)
          }
        }}))
      }else{
        setShowDeleteConfirmation(false)
      }
    
  }
  

  const renderDeleteConfirmBtn=()=>{
      return  <>
            <Dialog open={showDeleteConfirmation}
              onOpenChange={(isOpen) => {
                setShowDeleteConfirmation(isOpen);
              }}
            >
              <DialogContent className="max-w-[600px] max-h-[90vh] p-0 bg-flup-surface flex flex-col" >
                {/* Header */}
                <DialogHeader className="p-4 border-b">
                  <DialogTitle className="text-lg font-semibold">
                    Sport Delete Confirmation
                  </DialogTitle>
                </DialogHeader>


                    <div className=" w-full relative text-center">
                       <h4 className='font-bold'> Are you sure your want to delete the this Sport</h4>
                    </div>
                    <p className='text-3xl font-bold text-center text-green-600 '>{selectedSportNameToDelete}</p>


                {/* Footer */}
                <DialogFooter className="p-4 border-t flex gap-4">
                  <Button variant="outline" onClick={() => {
                       setSelectedSportIdToDelete(null)
                       setSelectedSportNameToDelete(null)
                      setShowDeleteConfirmation(false)
                    }} className="flex-1">
                    Close
                  </Button>
                  <Button variant="outline" onClick={() =>{
                    deleteConfirmHandler()
                  }} className="flex-1">
                    Proceed
                  </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>

      </>
  }
  const handleEditSport = (sportId: string, sportData: Sports) => {
    // setNewSport(sportData);
    dispatch(setEditSportAndCourtDetails({ sportsData: sportData }))
    setOpenEditmodal(true)


  }
  const normalize = (str) => str.trim().toLowerCase();


  const handleSubmit = () => {
    if (sports.length === 0 && VendorVenueDetailsById.payload?.sports?.length === 0) {
      // toast({ title: 'Error', description: 'Please add at least one sport', variant: 'destructive' });
      newToast.error('Please add at least one sport', { closeButton: true });

      return;
    }

    if((VendorVenueDetailsById.payload?.sports?.length < VendorVenueDetailsById.payload?.sportsCategories?.length) && !isFormInputChanged){

        // normalize helper

      // create a set of existing sports (sportType or name)
      const availableSportsSet = new Set(
        VendorVenueDetailsById.payload?.sports.map(sport => normalize(sport.sportType))
      );

        // check missing sports
        VendorVenueDetailsById.payload?.sportsCategories.forEach(category => {
          if (!availableSportsSet.has(normalize(category))) {
            newToast.error(`Please add sport-(${category})`, {
              closeButton: true,
            });
          }
        });

        return
    }

    let sporsType= VendorVenueDetailsById.payload?.sports?.map(ele=>ele.sportType) // get [Cricket,Footboll etc]
    let sportsCategories=  VendorVenueDetailsById.payload?.sportsCategories || []

    if(sporsType?.length != VendorVenueDetailsById?.payload?.sports?.length){
    
      let missingItems = sportsCategories?.filter(item => !sporsType.includes(item));
      newToast.error(`Please add category of ${missingItems[0]}.`, { closeButton: true });
      return;
    }

    if (sports.length > 0) {
      const sportsWithOutCourts = sports.find(sport => sport.courts.length === 0);
      const haveCourtToAllSports = sports.every(ele => ele.courts.length > 0)
      if (!haveCourtToAllSports && sportsWithOutCourts) {
        newToast.error(`Please add at least one court to your ${sportsWithOutCourts.sportType} category`, { closeButton: true });

        // toast({ title: 'Error', description: `Please add at least one court to your ${sportsWithOutCourts.sportType} category`, variant: 'destructive' });
        return;
      }
    }



    // toast({ title: 'Success', description: 'Sports and courts setup completed!' });
    // onNext();
    if (isFormInputChanged) {
      if (currentOnboardVenueDetails?.payload?._id) {
        updateVenue(currentOnboardVenueDetails?.payload?._id, (res) => {
          if (res?.payload) {
            setIsFormInputChanged(false)
            // toast({ title: 'Success', description: 'Sports and courts setup completed!' });
            newToast.success('Sports and courts setup completed!', { closeButton: true });
            dispatch(resetLocalSports())
            fetchVendorVenueDetailsById((refreshed) => {
              if (refreshed?.payload) {
                onNext();
              } else {
                newToast.error('Could not reload the venue, please try again', { closeButton: true });
              }
            })

          }
        })
      } else {
        // toast({ title: 'Error', description: 'Venue id required' });
        newToast.error('Venue id required', { closeButton: true });

      }
    } else {
      // toast({ title: 'Success', description: 'Nothing modified!' });
      newToast.success('Nothing modified!', { closeButton: true });

      onNext();
    }
  };


  const updateVenue = (venueId: String, cb: (res: any) => void) => {
    if (venueId) {
      let data = sports

      if (VendorVenueDetailsById.payload?.sports?.length > 0) {

        // if (sports.length > 0) {
        //   const excludedIds = VendorVenueDetailsById.payload.sports.map(ele => ele._id);
        //   data = sports.filter(sport => !excludedIds.includes(sport._id));
        // } else {
        // }

      }
      dispatch(venueUpdateById({
        payload: { 
          groundConfig: isSharedGround ? Strings.groundConfigRadio.shared : Strings.groundConfigRadio.independent,
          sports: data 
        }, venueId: venueId, callback: (res) => {
          if (cb) {
            cb(res)
          }
        }
      }))
    }
  }
  const handleClose = () => {
    fetchVendorVenueDetailsById()
    SetSelectedCourtId('')
    setOpenEditmodal(false);

  }

  const fetchVendorVenueDetailsById = (cb?: (res: any) => void) => {
    if (currentOnboardVenueDetails?.payload?._id) {
      dispatch(getVendorVenueDetailsById({
        pathparams: currentOnboardVenueDetails?.payload?._id, callback: (res) => {
          if (typeof cb === "function") {
            cb(res)
          }
        }
      }))
    }
  }

  const handleCloseDetailsModal = () => {

  }

  const handleCloseAddCourtModal = () => {
    setSelectedSportId('')
    setOpenAddCourtModal(false);

  }

  const renderViewSportDetailsModal = () => {
    if (sportDetailsToView) {
      return (
        <>
          <Dialog open={showSportDetails}
            onOpenChange={(isOpen) => {
              setShowSportDetails(isOpen);
              if (!isOpen) handleCloseDetailsModal();
            }}
          >
            <DialogContent className="max-w-[600px] max-h-[90vh] p-0 bg-flup-surface flex flex-col" >
              {/* Header */}
              <DialogHeader className="p-4 border-b">
                <DialogTitle className="text-lg font-semibold">
                  Sport & Court Details
                </DialogTitle>
              </DialogHeader>

              {/* <Card> */}


              <div className="flex-1 overflow-y-auto px-4">

                <div className="grid grid-cols-2 gap-4 px-4 py-2">
                <div>
                    <Label htmlFor="sport-type">Sport Category Type *</Label>
                    <p className='text-sm'>{sportDetailsToView?.sportType}</p>
                  </div>
                  <div>
                    <Label htmlFor="sport-name">Sport Name *</Label>
                    <p className='text-sm'>{sportDetailsToView?.name}</p>

                  </div>

                 
                </div>

                <div className="space-y-2 ml-0 px-4">
                  {sportDetailsToView.courts.map((court) => (
                    <Card key={court._id}>
                      <CardContent className="p-4 grid w-full grid-cols-2 relative">
                        <div className="flex justify-between items-start">
                          <div>
                            <h5 className="font-medium">{court.courtName}</h5>
                            <p className="text-sm text-flup-ink-2">Description: {court.description ? court.description : "NA"}</p>

                            <p className="text-sm text-flup-ink-3">
                              Size: {court.arenaSize.length} x {court.arenaSize.width} {court.arenaSize.unit}
                            </p>
                            <p className="text-sm text-flup-ink-3">
                              Slot Duration: {court.slotDurationInMinutes} minutes
                            </p>
                            <p className="text-sm">
                              Status: <span className={court.isActive ? 'text-green-600' : 'text-red-600'}>
                                {court.isActive ? 'Active' : 'Inactive'}
                              </span>
                            </p>
                          </div>
                        </div>

                        <div className="flex justify-between items-start">
                          <div>
                            <h5 className="font-medium">{"PricingRules"}</h5>

                            <h5 className="font-medium text-sm text-flup-ink">weekdays:</h5>
                            <p className="text-sm text-flup-ink-2">DayRate:{getPriceWithInr(court.pricingRules.weekday.dayRate)} | Night Rate:{getPriceWithInr(court.pricingRules.weekday.nightRate)}</p>



                            <h5 className="font-medium text-sm text-flup-ink">Weekends:</h5>
                            <p className="text-sm text-flup-ink-2">DayRate:{getPriceWithInr(court.pricingRules.weekend.dayRate)} | Night Rate:{getPriceWithInr(court.pricingRules.weekend.nightRate)}</p>


                            <h5 className="font-medium text-sm text-flup-ink">Holidays:</h5>
                            <p className="text-sm text-flup-ink-2">DayRate:{getPriceWithInr(court.pricingRules.holidays.dayRate)} | Night Rate:{getPriceWithInr(court.pricingRules.holidays.nightRate)}</p>


                            {/* <p className="text-sm text-flup-ink-3">
                                    Size: {court.arenaSize.length} x {court.arenaSize.width} {court.arenaSize.unit}
                                  </p>
                                  <p className="text-sm text-flup-ink-3">
                                    Slot Duration: {court.slotDurationInMinutes} minutes
                                  </p>
                                  <p className="text-sm">
                                    Status: <span className={court.isActive ? 'text-green-600' : 'text-red-600'}>
                                      {court.isActive ? 'Active' : 'Inactive'}
                                    </span>
                                  </p> */}
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>

              </div>
              {/* </Card> */}

              {/* Footer */}
              <DialogFooter className="p-4 border-t flex gap-4">
                <Button variant="outline" onClick={() => setShowSportDetails(false)} className="flex-1">
                  Close
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>

        </>
      )
    }

  }
  const renderEditModal = () => {
    if (openEditModal && editSportAndCourtDetails) {
      return (
        <>
          <Dialog open={openEditModal}
            onOpenChange={(isOpen) => {
              setOpenEditmodal(isOpen);
              if (!isOpen) handleClose();
            }}
          >
            <DialogContent className="max-w-[600px] max-h-[90vh] p-0 bg-flup-surface flex flex-col" >
              {/* Header */}
              <DialogHeader className="p-4 border-b">
                <DialogTitle className="text-lg font-semibold">
                  Edit Sport & Court
                </DialogTitle>
              </DialogHeader>

              {/* Scrollable Content */}
              <div className="flex-1 overflow-y-auto px-4">
                <Tabs defaultValue="sports" className="w-full">
                  <TabsList className="grid w-full grid-cols-2 mb-4 sticky top-0 z-10">
                    <TabsTrigger value="sports">Sports</TabsTrigger>
                    <TabsTrigger value="courts">Courts</TabsTrigger>
                  </TabsList>

                  {/* Sports Tab */}
                  <TabsContent value="sports" className="space-y-4">
                    <div className="border rounded-lg p-4">
                      <h3 className="text-lg font-semibold mb-4">Edit Sport</h3>
                      <div className="grid grid-cols-2 gap-4">
                      <div>
                          <Label htmlFor="sport-type">Sport Category Type *</Label>
                          <Input
                            id="sport-name"
                            disabled={true}
                            value={editSportAndCourtDetails.sportType}
                            placeholder="Enter sport name"
                          />
                          {/* <Select value={editSportAndCourtDetails.sportType} onValueChange={(value) => {
                            dispatch(updateEditSportDetails({ sportsData: { ...editSportAndCourtDetails, sportType: value } }))

                          }}>
                            <SelectTrigger>
                              <SelectValue placeholder="Select sport type" />
                            </SelectTrigger>
                            <SelectContent>
                              {sportsCategories?.map((type) => (
                                <SelectItem key={type} value={type}>{type}</SelectItem>
                              ))}
                            </SelectContent>
                          </Select> */}
                        </div>

                        <div>
                          <Label htmlFor="sport-name">Sport Name *</Label>
                          <Input
                            id="sport-name"
                            value={editSportAndCourtDetails?.name}
                            onChange={(e) => {
                              dispatch(updateEditSportDetails({ sportsData: { ...editSportAndCourtDetails, name: e.target.value } }))
                            }}
                            placeholder="Enter sport name"
                          />
                        </div>
                      
                      </div>
                      <div className="mt-4">
                        <Label htmlFor="sport-description">Description</Label>
                        <Textarea
                          id="sport-description"
                          value={editSportAndCourtDetails?.description || ''}
                          onChange={(e) => {
                            dispatch(updateEditSportDetails({ sportsData: { ...editSportAndCourtDetails, description: e.target.value } }))

                          }
                          }
                          placeholder="Describe this sport..."
                          rows={3}
                        />
                      </div>

                    </div>

                  </TabsContent>

                  {/* Courts Tab */}
                  <TabsContent value="courts" className="space-y-4">
                    <div className="border rounded-lg p-4">
                      <h3 className="text-lg font-semibold mb-4">Edit Court</h3>

                      <div className="grid grid-cols-2 gap-4 mb-4">

                        <div>
                          <Label htmlFor="court-sport">Select Court To Edit *</Label>
                          <Select value={selectedCourtId} onValueChange={SetSelectedCourtId}>
                            <SelectTrigger>
                              <SelectValue placeholder="Select Court" />
                            </SelectTrigger>
                            <SelectContent>
                              {editSportAndCourtDetails.courts.map((court) => (
                                <SelectItem key={court._id} value={court._id}>{court.courtName}</SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>
                      </div>
                      {selectedCourtId && <div>


                        <div className="grid grid-cols-2 gap-4 mb-4">

                          <div>
                            <Label htmlFor="court-name">Court Name *</Label>
                            <Input
                              id="court-name"
                              value={editSportAndCourtDetails.courts.find(ele => ele._id === selectedCourtId)?.courtName}
                              onChange={(e) => {
                                // dispatch(updateEditSportAndCourtDetails({ ...editSportAndCourtDetails, courtName: e.target.value }))

                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "courtName", value: e.target.value }))


                                // setNewCourt({ ...newCourt, courtName: e.target.value })
                              }}
                              placeholder="Enter court name"
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <Label htmlFor="court-description">Description</Label>
                          <Textarea
                            id="court-description"
                            // value={newCourt.description}
                            value={editSportAndCourtDetails?.courts.find(ele => ele?._id === selectedCourtId)?.description}

                            onChange={(e) => {
                              // setNewCourt({ ...newCourt, description: e.target.value })
                              dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "description", value: e.target.value }))

                            }}
                            placeholder="Describe this court..."
                            rows={3}
                          />
                        </div>

                        <div className="grid grid-cols-3 gap-4 mb-4">
                          <div>
                            <Label htmlFor="court-length">Length</Label>
                            <Input
                              id="court-length"
                              type="number"
                              // value={newCourt.arenaSize.length}
                              value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.arenaSize?.length}
                              onChange={(e) => {

                                //   setNewCourt({
                                //   ...newCourt,
                                //   arenaSize: { ...newCourt.arenaSize, length: parseFloat(e.target.value) || 0 }
                                // })
                                let data = {
                                  ...editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.arenaSize,
                                  length: parseFloat(e.target.value) || 0
                                }
                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "arenaSize", value: data }))


                              }}
                              placeholder="0"
                            />
                          </div>
                          <div>
                            <Label htmlFor="court-width">Width</Label>
                            <Input
                              id="court-width"
                              type="number"
                              // value={newCourt.arenaSize.width}
                              value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.arenaSize?.width}

                              onChange={(e) => {

                                //   setNewCourt({
                                //   ...newCourt,
                                //   arenaSize: { ...newCourt.arenaSize, width: parseFloat(e.target.value) || 0 }
                                // })

                                let data = {
                                  ...editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.arenaSize,
                                  width: parseFloat(e.target.value) || 0
                                }
                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "arenaSize", value: data }))


                              }}
                              placeholder="0"
                            />
                          </div>
                          <div>
                            <Label htmlFor="court-unit">Unit</Label>
                            <Select
                              // value={newCourt.arenaSize.unit}
                              value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.arenaSize?.unit}

                              onValueChange={(value: 'meters' | 'feet') => {

                                //   setNewCourt({
                                //   ...newCourt,
                                //   arenaSize: { ...newCourt.arenaSize, unit: value }
                                // })
                                let data = {
                                  ...editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.arenaSize,
                                  unit: value
                                }
                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "arenaSize", value: data }))
                              }}
                            >
                              <SelectTrigger>
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                <SelectItem value="meters">Meters</SelectItem>
                                <SelectItem value="feet">Feet</SelectItem>
                              </SelectContent>
                            </Select>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div className="flex items-center space-x-2">
                            <Switch
                              // checked={newCourt.isActive}
                              checked={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.isActive}
                              onCheckedChange={(checked) => {

                                //  setNewCourt({ ...newCourt, isActive: checked })
                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "isActive", value: checked }))

                              }}
                            />
                            <Label>Active Court</Label>
                          </div>
                          <div>
                            <Label htmlFor="slot-duration">Slot Duration</Label>
                            <Select
                              // value={newCourt.slotDurationInMinutes.toString()}
                              value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.slotDurationInMinutes?.toString()}

                              onValueChange={(value) => {

                                // setNewCourt({ ...newCourt, slotDurationInMinutes: parseInt(value) as 30 | 60 | 120 })
                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "slotDurationInMinutes", value: parseInt(value) as 30 | 60 | 120 }))
                              }}
                            >
                              <SelectTrigger>
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                {SLOT_DURATIONS.map((duration) => (
                                  <SelectItem key={duration} value={duration.toString()}>{duration} minutes</SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </div>



                          <div>
                            <Label htmlFor="slot-duration">Max Allowed Players(Optional)</Label>
                            <Select
                              // value={newCourt.slotDurationInMinutes.toString()}
                              value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.maxAllowedPlayers?.toString() || ""}

                              onValueChange={(value) => {

                                // setNewCourt({ ...newCourt, slotDurationInMinutes: parseInt(value) as 30 | 60 | 120 })
                                dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "maxAllowedPlayers", value: parseInt(value) }))
                              }}
                            >
                               <SelectTrigger>
                            <SelectValue  placeholder="Select Max Players"/>
                          </SelectTrigger>
                          <SelectContent>
                            {[2,4,6,8,10,12,14,16,18,20,22,24,25,30,40,50].map((ele) => (
                              <SelectItem key={ele} value={ele.toString()}>{ele} Players</SelectItem>
                            ))}
                          </SelectContent>
                            </Select>
                          </div>
                          
                        </div>

                        <div className="space-y-4 mb-4">
                          <h4 className="font-medium">Pricing Rules</h4>
                          {(['weekday', 'weekend', 'holidays'] as const).map((period) => (
                            <div key={period} className="border rounded p-3">
                              <h5 className="font-medium capitalize mb-2">{period} {period ==="weekday"?"(Mon-Fri)":period==="weekend" ?"(Sat-Sun)":""}</h5>
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <Label htmlFor={`${period}-day`}>Day Rate (₹) <span className="font-normal text-flup-ink-3">({Strings.pricingHours.day})</span></Label>
                                  <Input
                                    id={`${period}-day`}
                                    type="number"
                                    // value={newCourt.pricingRules[period].dayRate}
                                    value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.pricingRules?.[period]?.dayRate}

                                    onChange={(e) => {

                                      //   setNewCourt({
                                      //   ...newCourt,
                                      //   pricingRules: {
                                      //     ...newCourt.pricingRules,
                                      //     [period]: {
                                      //       ...newCourt.pricingRules[period],
                                      //       dayRate: parseFloat(e.target.value) || 0
                                      //     }
                                      //   }
                                      // })

                                      let court = editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)

                                      let data = {
                                        ...court.pricingRules,
                                        [period]: {
                                          ...court.pricingRules[period],
                                          dayRate: parseFloat(e.target.value) || 0
                                        }
                                      }

                                      dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "pricingRules", value: data }))


                                    }}
                                    placeholder="0"
                                  />
                                </div>
                                <div>
                                  <Label htmlFor={`${period}-night`}>Night Rate (₹) <span className="font-normal text-flup-ink-3">({Strings.pricingHours.night})</span></Label>
                                  <Input
                                    id={`${period}-night`}
                                    type="number"
                                    // value={newCourt.pricingRules[period].nightRate}
                                    value={editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)?.pricingRules?.[period]?.nightRate}
                                    onChange={(e) => {
                                      //   setNewCourt({
                                      //   ...newCourt,
                                      //   pricingRules: {
                                      //     ...newCourt.pricingRules,
                                      //     [period]: {
                                      //       ...newCourt.pricingRules[period],
                                      //       nightRate: parseFloat(e.target.value) || 0
                                      //     }
                                      //   }
                                      // })

                                      let court = editSportAndCourtDetails?.courts?.find(ele => ele._id === selectedCourtId)
                                      let data = {
                                        ...court.pricingRules,
                                        [period]: {
                                          ...court.pricingRules[period],
                                          nightRate: parseFloat(e.target.value) || 0
                                        }
                                      }
                                      dispatch(updateEditCourtDetails({ courtId: selectedCourtId, field: "pricingRules", value: data }))


                                    }}
                                    placeholder="0"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* <Button onClick={handleAddCourt} disabled={!selectedSportId}>
                        <Plus className="w-4 h-4 mr-2" />
                        Add Court
                      </Button> */}
                      </div>}
                    </div>

                  </TabsContent>
                </Tabs>
              </div>

              {/* Footer */}
              <DialogFooter className="p-4 border-t flex gap-4">
                <Button variant="outline" onClick={handleClose} className="flex-1">
                  Close
                </Button>
                <ButtonWithLoader
                  onClick={SaveEditHandler}
                  disabled={updateVendorSportAndCourtOnEditResponse.isLoading}
                  className="flex-1 bg-flup-brand hover:bg-flup-brand-press text-white"
                  isLoading={updateVendorSportAndCourtOnEditResponse.isLoading}
                  loaderPosition='right'
                >
                  Save
                </ButtonWithLoader>
              </DialogFooter>
            </DialogContent>
          </Dialog>

        </>
      )
    }
  }

  const saveNewCout = async () => {
    dispatch(addNewCourtInVendorSports({
      payload: addNewCourtState, callback: (res) => {
        if (res?.payload) {
          setOpenAddCourtModal(false)
          setConfigStatus(Strings.groundConfigRadio.independent)
          setSelectedGroundUsage(Strings.groundUsage.full)
          fetchVendorVenueDetailsById((res) => {
            setSelectedSportId('')
            // setCurrentTab('sports')
          })
        }
      }
    }))
  }

  const rederAddNewCourtModal = () => {
    return (
      <>
        <Dialog open={openAddCourtModal}
          onOpenChange={(isOpen) => {
            setOpenAddCourtModal(isOpen);
            if (!isOpen) handleCloseAddCourtModal();
          }}
        >


          <DialogContent className="max-w-[600px] max-h-[90vh] p-0 bg-flup-surface flex flex-col" >
            <DialogHeader className="p-4 border-b">
              <DialogTitle className="text-lg font-semibold">
                Add New Court
              </DialogTitle>
            </DialogHeader>


     

            <div className="flex-1 overflow-y-auto px-4">

         {isSharedGround &&   <div className="space-y-3 mb-4">
                <Label className="text-sm font-medium">Ground Configuration *</Label>
                <RadioGroup
                    value={ConfigStatus}
                    onValueChange={(value) => {
                      console.log("value:",value)
                      setConfigStatus(value)

                      if(value === Strings.groundConfigRadio.independent){
                        setSelectedGroundUsage(Strings.groundUsage.full)
                        dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "sharedGround", value: false }))
                      }
                      if(value === Strings.groundConfigRadio.shared){
                        dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "sharedGround", value: true }))
                      }
                    }}
                    className="flex flex-wrap gap-4"
                >
                    <div className="flex items-center space-x-2">
                        <RadioGroupItem value={Strings.groundConfigRadio.independent} id={Strings.groundConfigRadio.independent} />
                        <Label
                            htmlFor={`Independent Courts`}
                            // className={cn("flex items-center gap-1", getStatusColor('available'))}
                        >
                            Independent Courts
                        </Label>
                    </div>
                    <div className="flex items-center space-x-2">
                        <RadioGroupItem value={Strings.groundConfigRadio.shared} id={Strings.groundConfigRadio.shared}/>
                        <Label
                            htmlFor={`Split Same Ground`}
                            // className={cn("flex items-center gap-1", getStatusColor('booked'))}
                        >
                          Split Same Ground
                        </Label>
                    </div>
                  
                </RadioGroup>

                { ConfigStatus === Strings.groundConfigRadio.shared &&<div>
                      <Label htmlFor="court-sport">Select Ground Usage *</Label>
                      <Select value={selectedGroundUsage} onValueChange={(value)=>{
                        setSelectedGroundUsage(value)
                    
                        dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "courtType", value: value }))


                        }}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select ground usage percentage" />
                        </SelectTrigger>
                        <SelectContent>
                          {[
                            {key:"Full Ground (100%)",value:Strings.groundUsage.full},
                            {key:"Half Ground (50%)",value:Strings.groundUsage.half}
                          ].map((sport) => {
                              return (
                                <SelectItem key={sport.value} value={sport.value}>{sport.key}</SelectItem>
  
                              )
                          }
                         
                        )}
                        </SelectContent>
                      </Select>
                    </div>}
            </div>}


              <div className="border rounded-lg p-4">

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div className='flex items-center space-x-2'>
                    <Label htmlFor="court-sport">Sport Name:</Label>
                    <Label className='text-flup-info text-sm'>{VendorVenueDetailsById.payload?.sports && VendorVenueDetailsById?.payload?.sports?.find(ele => ele._id === selectedSportId)?.name}</Label>
                  </div>

                </div>

                {<>
                  <div>
                    <Label htmlFor="court-name">Court Name *</Label>
                    <Input
                      id="court-name"
                      value={addNewCourtState.courtData?.courtName}
                      onChange={(e) => {
                        dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "courtName", value: e.target.value }))
                      }}


                      placeholder="Enter court name"
                    />
                  </div>


                  <div className="mb-4">
                    <Label htmlFor="court-description">Description</Label>
                    <Textarea
                      id="court-description"
                      value={addNewCourtState.courtData?.description}
                      onChange={(e) => {

                        dispatch(setAddNewCourtState({ sportId: selectedSportId, venueId: VendorVenueDetailsById?.payload?._id, field: "description", value: e.target.value }))

                      }}
                      placeholder="Describe this court..."
                      rows={3}
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-4 mb-4">
                    <div>
                      <Label htmlFor="court-length">Length</Label>
                      <Input
                        id="court-length"
                        type="number"
                        value={addNewCourtState.courtData?.arenaSize?.length}
                        onChange={(e) => {
                          let data = {
                            ...addNewCourtState.courtData.arenaSize,
                            length: parseFloat(e.target.value) || 0
                          }
                          dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "arenaSize", value: data }))

                        }}
                        placeholder="0"
                      />
                    </div>
                    <div>
                      <Label htmlFor="court-width">Width</Label>
                      <Input
                        id="court-width"
                        type="number"
                        value={addNewCourtState.courtData?.arenaSize?.width}
                        onChange={(e) => {
                          let data = {
                            ...addNewCourtState.courtData.arenaSize,
                            width: parseFloat(e.target.value) || 0
                          }
                          dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "arenaSize", value: data }))

                        }}
                        placeholder="0"
                      />
                    </div>
                    <div>
                      <Label htmlFor="court-unit">Unit</Label>
                      <Select
                        value={addNewCourtState.courtData?.arenaSize?.unit}
                        onValueChange={(value: 'meters' | 'feet') => {
                          let data = {
                            ...addNewCourtState.courtData.arenaSize,
                            unit: value
                          }
                          dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "arenaSize", value: data }))
                        }}
                      >
                        <SelectTrigger>
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="meters">Meters</SelectItem>
                          <SelectItem value="feet">Feet</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div className="flex items-center space-x-2">
                      <Switch
                        checked={addNewCourtState.courtData?.isActive}
                        onCheckedChange={(checked) => {
                          dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "isActive", value: checked }))
                        }}
                      />
                      <Label>Active Court</Label>
                    </div>
                    <div>
                      <Label htmlFor="slot-duration">Slot Duration*</Label>
                      <Select
                        value={addNewCourtState.courtData?.slotDurationInMinutes?.toString()}
                        onValueChange={(value) => {

                          dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "slotDurationInMinutes", value: parseInt(value) as 30 | 60 | 120 }))


                        }}
                      >
                        <SelectTrigger>
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          {SLOT_DURATIONS.map((duration) => (
                            <SelectItem key={duration} value={duration.toString()}>{duration} minutes</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>

                    <div>
                        <Label htmlFor="slot-duration">Max Allowed Players(Optional)</Label>
                        <Select
                          value={addNewCourtState.courtData.maxAllowedPlayers?.toString() || ""}

                          onValueChange={(value) => {

                            dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "maxAllowedPlayers", value: parseInt(value) }))
  
  
                          }}
                        >
                          <SelectTrigger>
                            <SelectValue  placeholder="Select Max Players"/>
                          </SelectTrigger>
                          <SelectContent>
                            {[2,4,6,8,10,12,14,16,18,20,22,24,25,30,40,50].map((ele) => (
                              <SelectItem key={ele} value={ele.toString()}>{ele} Players</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                      
                  </div>

                  <div className="space-y-4 mb-4">
                    <h4 className="font-medium">Pricing Rules</h4>
                    {(['weekday', 'weekend', 'holidays'] as const).map((period) => (
                      <div key={period} className="border rounded p-3">
                        <h5 className="font-medium capitalize mb-2">{period} {period ==="weekday"?"(Mon-Fri)":period==="weekend" ?"(Sat-Sun)":""}</h5>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <Label htmlFor={`${period}-day`}>Day Rate (₹) <span className="font-normal text-flup-ink-3">({Strings.pricingHours.day})</span></Label>
                            <Input
                              id={`${period}-day`}
                              type="number"
                              value={addNewCourtState.courtData?.pricingRules[period]?.dayRate}
                              onChange={(e) => {
                                let data = {
                                  ...addNewCourtState.courtData?.pricingRules,
                                  [period]: {
                                    ...addNewCourtState.courtData.pricingRules[period],
                                    dayRate: parseFloat(e.target.value) || 0
                                  }
                                }
                                dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "pricingRules", value: data }))
                              }}
                              placeholder="0"
                            />
                          </div>
                          <div>
                            <Label htmlFor={`${period}-night`}>Night Rate (₹) <span className="font-normal text-flup-ink-3">({Strings.pricingHours.night})</span></Label>
                            <Input
                              id={`${period}-night`}
                              type="number"
                              value={addNewCourtState.courtData?.pricingRules[period]?.nightRate}
                              onChange={(e) => {


                                let data = {
                                  ...addNewCourtState.courtData?.pricingRules,
                                  [period]: {
                                    ...addNewCourtState.courtData.pricingRules[period],
                                    nightRate: parseFloat(e.target.value) || 0
                                  }
                                }
                                dispatch(setAddNewCourtState({ venueId: VendorVenueDetailsById?.payload?._id, sportId: selectedSportId, field: "pricingRules", value: data }))
                              }}
                              placeholder="0"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>}
              </div>
            </div>
            {/* Footer */}
            <DialogFooter className="p-4 border-t flex gap-4">
              <Button variant="outline" onClick={handleCloseAddCourtModal} className="flex-1">
                Close
              </Button>
              <ButtonWithLoader
                onClick={saveNewCout}
                disabled={addNewCourtInVendorSportsResponse.isLoading || VendorVenueDetailsById.isLoading}
                className="flex-1 bg-flup-brand hover:bg-flup-brand-press text-white"
                isLoading={addNewCourtInVendorSportsResponse.isLoading || VendorVenueDetailsById.isLoading}
                loaderPosition='right'
              >  <Plus className="w-4 h-4 mr-2" />
                Add Court
              </ButtonWithLoader>
            </DialogFooter>
          </DialogContent>
        </Dialog>

      </>
    )
  }


  const SaveEditHandler = () => {
    if (currentOnboardVenueDetails.payload) {
      updateSportAndCourts(currentOnboardVenueDetails.payload?._id, editSportAndCourtDetails._id, selectedCourtId)
    }
  }

  const updateSportAndCourts = (venueId: string, sportId: string, courtId: string) => {
    if (venueId && sportId) {
      let payload = {
        ...editSportAndCourtDetails
      }
      if(editSportAndCourtDetails?.courts?.length>0){
         payload.courts = editSportAndCourtDetails.courts.filter(ele=>ele?._id === courtId) 
      }
      if(!payload.courts?.length){
        newToast.error("Invalid court edit")
      }
      dispatch(updateVendorSportAndCourtOnEdit({
        payload: {
          courtId: courtId || '',
          sportId,
          venueId,
          updateData: payload
        }, callback: (res) => {
          if (res) {
            setOpenEditmodal(false)
            fetchVendorVenueDetailsById()
          }
        }
      }))
    }
  }

  if (VendorVenueDetailsById.isLoading) {
    return <VendorOnboardSkeleton />
  }


  const tabChangeHandler = (value: string) => {
    setCurrentTab(value as 'sports' | 'courts')
    setConfigStatus(Strings.groundConfigRadio.independent)
    setSelectedGroundUsage(Strings.groundUsage.full)
  }
  const checkAllSportsAdded=()=>{
    if(VendorVenueDetailsById.payload){
      let sporsType = VendorVenueDetailsById.payload?.sports?.map(ele=>ele.sportType) || [] // get [Cricket,Footboll etc]

      sporsType=[...sporsType]
      let sportsCategories=  VendorVenueDetailsById.payload?.sportsCategories || []    
        let missingItems = sportsCategories?.filter(item => !sporsType.includes(item));
        return missingItems
    }
   
  }
  const getSporTypeToReder=()=>{
    if(VendorVenueDetailsById.payload){
      let sporsType = VendorVenueDetailsById.payload?.sports?.map(ele=>ele.sportType) // get [Cricket,Footboll etc]
      let localsportType = sports.map(ele=>ele.sportType) // get [Cricket,Footboll etc]

      sporsType=[...sporsType,...localsportType]
      let sportsCategories=  VendorVenueDetailsById.payload?.sportsCategories || []    
      let missingItems = sportsCategories?.filter(item => !sporsType.includes(item));
        return missingItems
    }
  }


  // The tab lists saved sports and locally-added ones in two grids, so the
  // heading has to count both — counting only the saved ones showed
  // "Current Sports(0)" with an unsaved card sitting right underneath it.
  const totalSportsCount =
    (VendorVenueDetailsById?.payload?.sports?.length || 0) + (sports?.length || 0);

  const handleCategorySubmit = () => {
    if (selectedCategoriesFromProps?.length === 0) {
      toast({ title: 'Error', description: 'Please select at least one sports category', variant: 'destructive' });
      return;
    }

    if (isCategoriesFormInputChanged) {
      setIsFormInputChanged(false)
      dispatch(setSportsCategories(selectedCategoriesFromProps));
      if (currentOnboardVenueDetails?.payload?._id) {
          dispatch(venueUpdateById({
            payload: { sportsCategories: selectedCategoriesFromProps }, venueId: currentOnboardVenueDetails?.payload?._id, callback: (res) => {
              // toast({ title: 'Success', description: 'Sports categories saved!' });
              fetchVendorVenueDetailsById()
              setShowAddNewSport(false)
            }
          }))
      } else {
        toast({ title: 'Error', description: 'Venue id required' });
      }
    } 
  }


  const renderAddNewSportModal = () => {
    if (showAddNewSport) {
      return (
        <>
          <Dialog open={showAddNewSport}
            onOpenChange={(isOpen) => {
              setShowAddNewSport(isOpen);
              // if (!isOpen) setShowAddNewSport(false);
            }}
          >
            <DialogContent className="max-w-[600px] max-h-[70vh] p-0 bg-flup-surface flex flex-col" >
              {/* Header */}
              <DialogHeader className="p-4 border-b">
                <DialogTitle className="text-lg font-semibold">
                  Select Sport To Add
                </DialogTitle>
              </DialogHeader>

              {/* <Card> */}


              <div className="flex-1 overflow-y-auto px-4">

                <SportsCategoriesForm 
                  onNext={()=>{}}
                  onBack={()=>{}}
                  showActions={false}
                  selectedCategoriesFromProps={selectedCategoriesFromProps}
                  setIsCategoriesFormInputChanged={setIsCategoriesFormInputChanged}
                  setSelectedCategoriesFromProps={setSelectedCategoriesFromProps}
                />

              </div>
              {/* </Card> */}

              {/* Footer */}
              <DialogFooter className="p-4 border-t flex gap-4">
                <Button variant="destructive" onClick={() => setShowAddNewSport(false)} 
                
                className="flex-1">
                  Close
                </Button>

                <ButtonWithLoader variant="default" 
                isLoading={venueUpdateByIdResponse.isLoading}
                onClick={() => {

                  handleCategorySubmit()
                }} className="flex-1">
                  Save
                </ButtonWithLoader>
              </DialogFooter>
            </DialogContent>
          </Dialog>

        </>
      )
    }

  }

  
  const handleAddNewSport=()=>{
      setShowAddNewSport(true)
  }
  return (
    <>
    {renderAddNewSportModal()}
    {renderDeleteConfirmBtn()}
      {renderViewSportDetailsModal()}
      {renderEditModal()}
      {rederAddNewCourtModal()}

      <div className="flex items-start justify-center">

        <Card className="w-full max-w-2xl">

          <CardHeader>
          <div className='flex justify-between items-center'>

            <div>
            <CardTitle className="text-2xl font-bold">Sports & Courts Management</CardTitle>
            <CardDescription>Configure your sports and courts</CardDescription>
            </div>
          
                  <Button
                  onClick={handleAddNewSport}
                  > <PlusIcon/> Edit sport categories</Button>
            </div>
          </CardHeader>
        
          <CardContent className="space-y-6">
            {VendorVenueDetailsById.payload ?
            <Tabs defaultValue="sports" className="w-full"
              value={currentTab}
              onValueChange={(value) => tabChangeHandler(value as 'sports' | 'courts')}
            >
                  {
                checkAllSportsAdded()?.length>0?
                <>
              <div className="border rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-2">
                  <Switch
                    checked={isSharedGround}
                    onCheckedChange={(checked) => {
                      setIsFormInputChanged(true)
                      setisSharedGround(checked)
                    }}
                  />
                  <Label>Is this a shared ground (multiple courts or sports use the same playing area)?</Label>
                </div>
                <p className="text-sm text-flup-ink-3 mt-2">
                  This applies to the whole venue, not to a single sport.
                </p>
              </div>

              <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="sports">Sports</TabsTrigger>
                <TabsTrigger value="courts" disabled={ sports?.length === 0}>Courts</TabsTrigger>
              </TabsList>

              <TabsContent value="sports" className="space-y-4">
                <div className="border rounded-lg p-4">
                  <h3 className="text-lg font-semibold mb-4">Add New Sport</h3>
                  <div className="grid grid-cols-2 gap-4">
                  <div>
                      <Label htmlFor="sport-type">Sport Category Type *</Label>
                      <Select value={newSport.sportType} onValueChange={(value) => {
                        setIsFormInputChanged(true)
                        setNewSport((prev) => ({
                          ...prev,
                          sportType: value,
                          name: !prev.name || prev.name === prev.sportType ? value : prev.name,
                        }))
                      }}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select sport type" />
                        </SelectTrigger>
                        <SelectContent>
                          {getSporTypeToReder()?.map((type) => (
                            <SelectItem key={type} value={type}>{type}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div>
                      <Label htmlFor="sport-name">Sport Name *</Label>
                      <Input
                       disabled={!newSport.sportType}
                        id="sport-name"
                        value={newSport.name}
                        onChange={(e) => {
                          setIsFormInputChanged(true)
                          setNewSport({ ...newSport, name: e.target.value })
                          setNewCourt(initialCourtData)
                        }}
                        placeholder="Enter sport name"
                      />
                    </div>

                    {!newSport.sportType && (
                      <p className="col-span-2 text-sm text-flup-ink-3">
                        Pick a sport category first to fill in the rest.
                      </p>
                    )}

                 
                   
                  </div>

                  <div className="mt-4">
                    <Label htmlFor="sport-description">Description</Label>
                    <Textarea
                      id="sport-description"
                      disabled={!newSport.sportType}
                      value={newSport.description}
                      onChange={(e) => {
                        setIsFormInputChanged(true)
                        setNewSport({ ...newSport, description: e.target.value })
                      }
                      }
                      placeholder="Describe this sport..."
                      rows={3}
                    />
                  </div>
                  <Button
                  disabled={!newSport.name || !newSport.sportType}
                  onClick={handleAddSport} className="mt-4">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Sport
                  </Button>
                </div>

                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">Current Sports ({totalSportsCount})</h3>

                  {totalSportsCount === 0 && (
                    <p className="text-sm text-flup-ink-3">
                      No sports added yet. Choose a category above and use Add Sport to create one.
                    </p>
                  )}

                  <div className='grid w-full grid-cols-1  lg:grid-cols-2 gap-2 '>

                    {VendorVenueDetailsById?.payload?.sports && VendorVenueDetailsById?.payload.sports.map((sport) => (
                      <Card key={sport?._id} >
                        <CardContent className="p-4">
                          <div>
                            <h4 className="font-medium flex items-center">Name: {sport.name} <CheckCircle2 className='w-4 h-4 ml-2 text-green-600' /></h4>
                            <p className="text-sm text-flup-ink-2">Category: {sport.sportType}</p>
                            <p className="text-sm text-flup-ink-2  mt-1">Description:</p>
                            <p className="text-sm text-flup-ink-3 truncate line-clamp-2">{sport.description}</p>
                            <div className='text-sm  flex items-center'>
                              <p className="text-sm text-flup-info flex items-center">
                                No. of courts: {sport.courts.length}
                              </p>

                              <span className='p-1 text-flup-ink-3 flex items-center'>|</span>

                              <div className='flex items-center text-green-500 hover:text-green-700 cursor-pointer' onClick={() => {
                                setShowSportDetails(true)
                                setSportDetailsToView(sport)
                              }}>
                                <Eye className='w-4 h-4 text-xs' />View
                              </div>

                            </div>


                            <div className="flex flex-row justify-start items-center h-full flex-wrap">
                              <ButtonWithLoader className='text-xs w-18 m-1 hover:bg-green-600 cursor-pointer'
                               onClick={() => handleEditSport(sport._id, sport)}><Pencil className='w-4 h-4 ' />Edit</ButtonWithLoader>
                              
                              <ButtonWithLoader className='text-xs w-18 m-1  bg-flup-info-soft0 hover:bg-blue-600 cursor-pointer' onClick={() => {
                                setOpenAddCourtModal(true)
                                dispatch(resetAddNewCourtState())
                                setSelectedSportId(sport._id)
                              }}>
                                <Plus className='w-4 h-4 ' />Add Court</ButtonWithLoader>

                               {showDeleteButtonForSaveVenues && <ButtonWithLoader 
                                disabled={deleteSportByIdResponse.isLoading}
                                isLoading={deleteSportByIdResponse.isLoading && selectedSportIdToDelete === sport._id } 
                                className='text-xs w-10 m-1 bg-red-500 hover:bg-red-600 cursor-pointer' 
                                onClick={() => handleDeleteSportFromDb(sport._id,VendorVenueDetailsById?.payload?._id,sport?.sportType)} >
                                {!(deleteSportByIdResponse.isLoading  && selectedSportIdToDelete === sport._id) &&
                                  <Trash className='w-4 h-4' />}
                                </ButtonWithLoader>}
                            </div>

                          </div>
                        </CardContent>
                      </Card>
                    ))}


                  </div>

                  <div className='grid w-full grid-cols-1  sm:grid-cols-2 gap-2 '>

                    {/* ---------------- */}

                    {sports.map((sport) => (
                      <Card key={sport?._id} >
                        <CardContent className="p-4">
                          <div>
                            <h4 className="font-medium flex items-center">Name: {sport.name}
                            <span className='text-sm ml-2 text-flup-ink-3'>
                              {"(Unsaved Venue)"}
                              </span>  <TriangleAlert className='w-4 h-4 ml-2 text-orange-600' /></h4>
                            <p className="text-sm text-flup-ink-2">Category: {sport.sportType}</p>
                            <p className="text-sm text-flup-ink-2  mt-1">Description:</p>
                            <p className="text-sm text-flup-ink-3 truncate line-clamp-2">{sport.description}</p>
                            <p className="text-sm text-flup-info mt-1">No. of courts: {sport.courts.length}</p>

                            <div className="flex flex-row justify-start items-center h-full space-x-2 mt-1">
                              <ButtonWithLoader className='text-xs w-18 h-[34px] hover:bg-green-600 cursor-pointer' 
                              // disabled={true}
                                 onClick={() =>{
                                  setCurrentTab("courts")
                                  setSelectedSportId(sport?._id)
                                  // setNewCourt((prev)=>{
                                  //   return {
                                  //     ...prev,
                                  //       :
                                  //   }
                                  // })
                                  // handleEditSport(sport._id, sport)
                                 }}>
                                 <Pencil className='w-4 h-4 ' />Edit
                                </ButtonWithLoader>
                              <ButtonWithLoader className='text-xs w-10 h-[34px] bg-red-500 hover:bg-red-600 cursor-pointer' onClick={() => handleDeleteSport(sport._id)} >

                                <Trash className='w-4 h-4' /></ButtonWithLoader>                            </div>

                          </div>
                          <p className='text-red-500 text-[12px] text-start mt-2 font-medium'>It is in pending state, please fill all courts details and save it.</p>

                        </CardContent>
                      </Card>
                    ))}
                  </div>

                </div>
              </TabsContent>

                  {/* Desktop */}
              <TabsContent value="courts" className="space-y-4">
                <div className="border rounded-lg p-4">


                {isSharedGround &&    <div className="space-y-3 mb-4">
                <Label className="text-sm font-medium">Ground Configuration *</Label>
                <RadioGroup
                    value={ConfigStatus}
                    onValueChange={(value) => {
                      console.log("value:",value)
                      setConfigStatus(value)

                      if(value === Strings.groundConfigRadio.independent){
                        setSelectedGroundUsage(Strings.groundUsage.full)
                        setNewCourt({ ...newCourt, sharedGround:false })

                      }
                      if(value === Strings.groundConfigRadio.shared){
                        setNewCourt({ ...newCourt, sharedGround:true })
                      }
                    }}
                    className="flex flex-wrap gap-4"
                >
                    <div className="flex items-center space-x-2">
                        <RadioGroupItem value={Strings.groundConfigRadio.independent} id={Strings.groundConfigRadio.independent} />
                        <Label
                            htmlFor={`Independent Courts`}
                            // className={cn("flex items-center gap-1", getStatusColor('available'))}
                        >
                            Independent Courts
                        </Label>
                    </div>
                    <div className="flex items-center space-x-2">
                        <RadioGroupItem value={Strings.groundConfigRadio.shared} id={Strings.groundConfigRadio.shared}/>
                        <Label
                            htmlFor={`Split Same Ground`}
                            // className={cn("flex items-center gap-1", getStatusColor('booked'))}
                        >
                          Split Same Ground
                        </Label>
                    </div>
                  
                </RadioGroup>

                { ConfigStatus === Strings.groundConfigRadio.shared &&<div>
                      <Label htmlFor="court-sport">Select Ground Usage *</Label>
                      <Select value={selectedGroundUsage} onValueChange={(value)=>{
                        setSelectedGroundUsage(value)
                        if(value){
                          setNewCourt({ ...newCourt, courtType:value })
                        }
                        }}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select ground usage percentage" />
                        </SelectTrigger>
                        <SelectContent>
                          {[
                            {key:"Full Ground (100%)",value:Strings.groundUsage.full},
                            {key:"Half Ground (50%)",value:Strings.groundUsage.half}
                          ].map((sport) => {
                              return (
                                <SelectItem key={sport.value} value={sport.value}>{sport.key}</SelectItem>
  
                              )
                          }
                         
                        )}
                        </SelectContent>
                      </Select>
                    </div>}
            </div>}


                  <p className="text-md font-semibold mb-2">Add New Court</p>

                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <Label htmlFor="court-sport">Select Sport Name *</Label>
                      <Select value={selectedSportId} onValueChange={setSelectedSportId}>
                        <SelectTrigger>
                          <SelectValue placeholder="Select sport" />
                        </SelectTrigger>
                        <SelectContent>
                          {sports.map((sport) => {
                              return (
                                <SelectItem key={sport._id} value={sport._id}>{sport.name}</SelectItem>
  
                              )
                          }
                         
                        )}
                          {/* {
                            getSporTypeToReder()?.in
                          } */}
                        </SelectContent>
                      </Select>
                    </div>
                    {selectedSportId && <div>
                      <Label htmlFor="court-name">Court Name *</Label>
                      <Input
                        id="court-name"
                        value={newCourt.courtName}
                        onChange={(e) => setNewCourt({ ...newCourt, courtName: e.target.value })}
                        placeholder="Enter court name"
                      />
                    </div>}
                  </div>

                  {selectedSportId && <>


                    <div className="mb-4">
                      <Label htmlFor="court-description">Description</Label>
                      <Textarea
                        id="court-description"
                        value={newCourt.description}
                        onChange={(e) => setNewCourt({ ...newCourt, description: e.target.value })}
                        placeholder="Describe this court..."
                        rows={3}
                      />
                    </div>

                    <div className="grid grid-cols-3 gap-4 mb-4">
                      <div>
                        <Label htmlFor="court-length">Length</Label>
                        <Input
                          id="court-length"
                          type="number"
                          value={newCourt.arenaSize.length || null}

                          inputMode="numeric"
                          onWheel={(e) => e.currentTarget.blur()}
                            /* ❌ Block negative sign & exponent */
                          onKeyDown={(e) => {
                            if (["-", "e", "E", "+"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}

                          onChange={(e) => setNewCourt({
                            ...newCourt,
                            arenaSize: { ...newCourt.arenaSize, length: parseFloat(e.target.value) || 0 }
                          })}
                          placeholder="0"
                        />
                      </div>
                      <div>
                        <Label htmlFor="court-width">Width</Label>
                        <Input
                          id="court-width"
                          type="number"
                          value={newCourt.arenaSize.width || null}

                          inputMode="numeric"
                          onWheel={(e) => e.currentTarget.blur()}
                            /* ❌ Block negative sign & exponent */
                          onKeyDown={(e) => {
                            if (["-", "e", "E", "+"].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}

                          onChange={(e) => setNewCourt({
                            ...newCourt,
                            arenaSize: { ...newCourt.arenaSize, width: parseFloat(e.target.value) || 0 }
                          })}
                          placeholder="0"
                        />
                      </div>
                      <div>
                        <Label htmlFor="court-unit">Unit</Label>
                        <Select
                          value={newCourt.arenaSize.unit}
                          onValueChange={(value: 'meters' | 'feet') => setNewCourt({
                            ...newCourt,
                            arenaSize: { ...newCourt.arenaSize, unit: value }
                          })}
                        >
                          <SelectTrigger>
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="meters">Meters</SelectItem>
                            <SelectItem value="feet">Feet</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div className="flex items-center space-x-2">
                        <Switch
                          checked={newCourt.isActive}
                          onCheckedChange={(checked) => setNewCourt({ ...newCourt, isActive: checked })}
                        />
                        <Label>Active Court</Label>
                      </div>
                      <div>
                        <Label htmlFor="slot-duration">Slot Duration*</Label>
                        <Select
                          value={newCourt.slotDurationInMinutes.toString()}
                          onValueChange={(value) => setNewCourt({ ...newCourt, slotDurationInMinutes: parseInt(value) as 30 | 60 | 120 })}
                        >
                          <SelectTrigger>
                            <SelectValue />
                          </SelectTrigger>
                          <SelectContent>
                            {SLOT_DURATIONS.map((duration) => (
                              <SelectItem key={duration} value={duration.toString()}>{duration} minutes</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>

                      <div>
                        <Label htmlFor="slot-duration">Max Allowed Players(Optional)</Label>
                        <Select
                          value={newCourt.maxAllowedPlayers?.toString() || ""}
                          onValueChange={(value) => setNewCourt({ ...newCourt, maxAllowedPlayers: parseInt(value)})}
                        >
                          <SelectTrigger>
                            <SelectValue  placeholder="Select Max Players"/>
                          </SelectTrigger>
                          <SelectContent>
                            {[2,4,6,8,10,12,14,16,18,20,22,24,25,30,40,50].map((ele) => (
                              <SelectItem key={ele} value={ele.toString()}>{ele} Players</SelectItem>
                            ))}
                          </SelectContent>
                        </Select>
                      </div>
                    </div>

                    <div className="space-y-4 mb-4">
                      <h4 className="font-medium">Pricing Rules</h4>
                      {(['weekday', 'weekend', 'holidays'] as const).map((period) => (
                        <div key={period} className="border rounded p-3">
                          <h5 className="font-medium capitalize mb-2">{period} {period ==="weekday"?"(Mon-Fri)":period==="weekend" ?"(Sat-Sun)":""}</h5>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <Label htmlFor={`${period}-day`}>Day Rate (₹) <span className="font-normal text-flup-ink-3">({Strings.pricingHours.day})</span></Label>
                              <Input
                                id={`${period}-day`}
                                type="number"
                                inputMode="numeric"
                                onWheel={(e) => e.currentTarget.blur()}
                                  /* ❌ Block negative sign & exponent */
                                onKeyDown={(e) => {
                                  if (["-", "e", "E", "+"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                value={newCourt.pricingRules[period].dayRate >0 ?newCourt.pricingRules[period].dayRate:null }
                                onChange={(e) => setNewCourt({
                                  ...newCourt,
                                  pricingRules: {
                                    ...newCourt.pricingRules,
                                    [period]: {
                                      ...newCourt.pricingRules[period],
                                      dayRate: parseFloat(e.target.value) 
                                    }
                                  }
                                })}
                                placeholder="0"
                              />
                            </div>
                            <div>
                              <Label htmlFor={`${period}-night`}>Night Rate (₹) <span className="font-normal text-flup-ink-3">({Strings.pricingHours.night})</span></Label>
                              <Input
                                id={`${period}-night`}
                                inputMode="numeric"
                                onWheel={(e) => e.currentTarget.blur()}
                                  /* ❌ Block negative sign & exponent */
                                onKeyDown={(e) => {
                                  if (["-", "e", "E", "+"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                type="number"
                                value={newCourt.pricingRules[period].nightRate || null}
                                onChange={(e) => setNewCourt({
                                  ...newCourt,
                                  pricingRules: {
                                    ...newCourt.pricingRules,
                                    [period]: {
                                      ...newCourt.pricingRules[period],
                                      nightRate: parseFloat(e.target.value) 
                                    }
                                  }
                                })}
                                placeholder="0"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <Button onClick={handleAddCourt} disabled={!selectedSportId}>
                      <Plus className="w-4 h-4 mr-2" />
                      Add Court
                    </Button>
                  </>}
                </div>

                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">All Courts</h3>
                  {sports.map((sport) => (
                    sport.courts.length > 0 && (
                      <div key={sport._id}>
                        <h4 className="font-medium text-flup-info mb-2">Sport Name: {sport.name}</h4>
                        <div className="space-y-2 ml-0">
                          {sport.courts.map((court) => (
                            <Card key={court._id}>
                              <CardContent className="p-4 grid w-full grid-cols-2 relative">
                                <X className='h-4 w-4 absolute top-4 right-4 cursor-pointer' onClick={() => handleDeleteCourt(sport._id, court._id)} />
                                <div className="flex justify-between items-start">
                                  <div>
                                    <h5 className="font-medium">{court.courtName}</h5>
                                    <p className="text-sm text-flup-ink-2">Description: {court.description ? court.description : "NA"}</p>
                                    <p className="text-sm text-flup-ink-3">
                                      Sport Category: {sport.sportType}
                                    </p>
                                    <p className="text-sm text-flup-ink-3">
                                      Size: {court.arenaSize.length} x {court.arenaSize.width} {court.arenaSize.unit}
                                    </p>
                                    <p className="text-sm text-flup-ink-3">
                                      Slot Duration: {court.slotDurationInMinutes} minutes
                                    </p>
                                    <p className="text-sm">
                                      Status: <span className={court.isActive ? 'text-green-600' : 'text-red-600'}>
                                        {court.isActive ? 'Active' : 'Inactive'}
                                      </span>
                                    </p>
                                  </div>
                                </div>

                                <div className="flex justify-between items-start">
                                  <div>
                                    <h5 className="font-medium">{"PricingRules"}</h5>

                                    <h5 className="font-medium text-sm text-flup-ink">weekdays:</h5>
                                    <p className="text-sm text-flup-ink-2">DayRate:{getPriceWithInr(court.pricingRules.weekday.dayRate)} | Night Rate:{getPriceWithInr(court.pricingRules.weekday.nightRate)}</p>



                                    <h5 className="font-medium text-sm text-flup-ink">Weekends:</h5>
                                    <p className="text-sm text-flup-ink-2">DayRate:{getPriceWithInr(court.pricingRules.weekend.dayRate)} | Night Rate:{getPriceWithInr(court.pricingRules.weekend.nightRate)}</p>


                                    <h5 className="font-medium text-sm text-flup-ink">Holidays:</h5>
                                    <p className="text-sm text-flup-ink-2">DayRate:{getPriceWithInr(court.pricingRules.holidays.dayRate)} | Night Rate:{getPriceWithInr(court.pricingRules.holidays.nightRate)}</p>


                                    {/* <p className="text-sm text-flup-ink-3">
                                    Size: {court.arenaSize.length} x {court.arenaSize.width} {court.arenaSize.unit}
                                  </p>
                                  <p className="text-sm text-flup-ink-3">
                                    Slot Duration: {court.slotDurationInMinutes} minutes
                                  </p>
                                  <p className="text-sm">
                                    Status: <span className={court.isActive ? 'text-green-600' : 'text-red-600'}>
                                      {court.isActive ? 'Active' : 'Inactive'}
                                    </span>
                                  </p> */}
                                  </div>
                                </div>
                              </CardContent>
                            </Card>
                          ))}
                        </div>
                      </div>
                    )
                  ))}
                </div>
              </TabsContent>
              </>
              :
              <>
          {/* Diplay if all sports are onboarded */}
              <div className="space-y-4">
                <div className='flex justify-between items-center'>
                <h3 className="text-lg font-semibold">Current Sports Count ({VendorVenueDetailsById?.payload?.sports?.length || 0})</h3>
                  {/* <Button
                  onClick={handleAddNewSport}
                  > <PlusIcon/> Add New Sport</Button> */}
                </div>
                  <div className='grid w-full grid-cols-1  lg:grid-cols-2 gap-2 '>

                    {VendorVenueDetailsById?.payload?.sports && VendorVenueDetailsById?.payload.sports.map((sport) => (
                      <Card key={sport?._id} >
                        <CardContent className="p-4">
                          <div>
                            <h4 className="font-medium flex items-center">Name: {sport.name} <CheckCircle2 className='w-4 h-4 ml-2 text-green-600' /></h4>
                            <p className="text-sm text-flup-ink-2">Category: {sport.sportType}</p>
                            <p className="text-sm text-flup-ink-2  mt-1">Description:</p>
                            <p className="text-sm text-flup-ink-3 truncate line-clamp-2">{sport.description}</p>
                            <div className='text-sm  flex items-center'>
                              <p className="text-sm text-flup-info flex items-center">
                                No. of courts: {sport.courts.length}
                              </p>

                              <span className='p-1 text-flup-ink-3 flex items-center'>|</span>

                              <div className='flex items-center text-green-500 hover:text-green-700 cursor-pointer' onClick={() => {
                                setShowSportDetails(true)
                                setSportDetailsToView(sport)
                              }}>
                                <Eye className='w-4 h-4 text-xs' />View
                              </div>

                            </div>


                           {!VendorVenueDetailsById?.payload?.oneTimeOnboardingFeeDetails?.isPaymentdone && <div className="flex flex-row justify-start items-center h-full space-x-2 mt-1">
                              <ButtonWithLoader className='text-xs w-18 h-[34px] hover:bg-green-600 cursor-pointer' onClick={() => handleEditSport(sport._id, sport)}><Pencil className='w-4 h-4 ' />Edit</ButtonWithLoader>
                              <ButtonWithLoader className='text-xs w-18 h-[34px] bg-flup-info-soft0 hover:bg-blue-600 cursor-pointer' onClick={() => {
                                setOpenAddCourtModal(true)
                                dispatch(resetAddNewCourtState())
                                setSelectedSportId(sport._id)
                              }}><Plus className='w-4 h-4 ' />Add Court</ButtonWithLoader>

                              <ButtonWithLoader
                              disabled={deleteSportByIdResponse.isLoading}
                              isLoading={deleteSportByIdResponse.isLoading  && selectedSportIdToDelete === sport._id} 
                                 onClick={() => handleDeleteSportFromDb(sport._id,VendorVenueDetailsById?.payload?._id,sport?.sportType)} 

                              className='text-xs w-10 h-[34px] bg-red-500 hover:bg-red-600 cursor-pointer'
                               >
                               {!(deleteSportByIdResponse.isLoading  && selectedSportIdToDelete === sport._id) &&
                                <Trash className='w-4 h-4' />}
                                </ButtonWithLoader>
                            </div>}

                          </div>
                        </CardContent>
                      </Card>
                    ))}


                  </div>

                  <div className='grid w-full grid-cols-1  sm:grid-cols-2 gap-2 '>

                    {/* ---------------- */}

                    {sports?.map((sport) => (
                      <Card key={sport?._id} >
                        <CardContent className="p-4">
                          <div>
                            <h4 className="font-medium flex items-center">Name: {sport.name} <TriangleAlert className='w-4 h-4 ml-2 text-orange-600' /></h4>
                            <p className="text-sm text-flup-ink-2">Category: {sport.sportType}</p>
                            <p className="text-sm text-flup-ink-2  mt-1">Description:</p>
                            <p className="text-sm text-flup-ink-3 truncate line-clamp-2">{sport.description}</p>
                            <p className="text-sm text-flup-info mt-1">No. of courts: {sport.courts.length}</p>

                            <div className="flex flex-row justify-start items-center h-full space-x-2 mt-1">
                              <ButtonWithLoader className='text-xs w-18 h-[34px] hover:bg-green-600 cursor-pointer' onClick={() => handleEditSport(sport._id, sport)}><Pencil className='w-4 h-4 ' />Edit</ButtonWithLoader>
                               {showDeleteButtonForSaveVenues &&<ButtonWithLoader className='text-xs w-10 h-[34px] bg-red-500 hover:bg-red-600 cursor-pointer' onClick={() => handleDeleteSport(sport._id)} >

                                <Trash className='w-4 h-4' /></ButtonWithLoader>    }                        </div>

                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                  {VendorVenueDetailsById?.payload?.oneTimeOnboardingFeeDetails?.isPaymentdone &&  <Card className='p-2'>

                 
                        <p className='text-sm font-medium text-green-700 '>To edit your sports & court data please connect with support@bookyourzone.com </p>
                                  
                      <p className='text-sm font-medium text-green-700 flex item-center justify-start gap-2 '>Support Number: 8074219474, 9381239569 </p>
                 
                      <p className='text-sm font-bold text-black/70 '>Note:* To add new sports category please go back and select new category. </p>
                    </Card>}

                </div>
              </>
              }
            </Tabs>:
            <>Loading...</>
            }

            {showActions &&<div className="flex gap-4 pt-4">
              <Button variant="outline" onClick={()=>{
                dispatch(resetLocalSports())
                onBack()
              }} className="flex-1">
                Back
              </Button>
              <ButtonWithLoader
                disabled={VendorVenueDetailsById.isLoading || venueUpdateByIdResponse.isLoading || totalSportsCount === 0}
                isLoading={VendorVenueDetailsById.isLoading || venueUpdateByIdResponse.isLoading}
                onClick={handleSubmit} className="flex-1 bg-flup-brand hover:bg-flup-brand-press text-white">
                Save and proceed
              </ButtonWithLoader>
            </div>}
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default SportsManagementForm;
